import { ListLayout } from 'components/common/ListLayout'
import React from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointmentView } from 'slices/inviteInterpreterSlice';
import { fetchInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import { inviteInterpretersSelector } from 'slices/inviteInterpreterSlice';
import { removeInvitedInterpreters } from 'slices/inviteInterpreterSlice';
import Swal from 'sweetalert2';

const AppointedInterpretersList = ({ itemId, fetchAppointment,height }) => {
    const dispatch = useDispatch()
    const { last_page: totalPages, loader, invitedInterpreters } = useSelector(inviteInterpretersSelector);
    const appointment = invitedInterpreters?.invites
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}

    });
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);

    const fetchData = async () => {
        dispatch(fetchInvitedInterpreters(itemId))
    };

    React.useEffect(() => {
        fetchData();
    }, [itemId]);


    const handleAddInviteInterpreterPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const handleSubmitInviteInterpreters = React.useCallback(() => {

        const submitCallback = (status, message) => {
            if (status) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                dispatch(fetchAppointmentView(itemId))
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to Remove them?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(removeInvitedInterpreters({ interpreter_ids: selectedItems, }, itemId, submitCallback))
            }
        })
    }, [selectedItems])

    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(appointment.map((inviteInterpreter) => inviteInterpreter.id.toString()))
    }, [selectedItems, selectAll, appointment])



    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                {/* <th className="col-1">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Code</p>
                    </div>
                </th> */}
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-2">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Phone</p>
                    </div>
                </th>
                {/* <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th> */}

            </tr>
        )
    }, [selectedItems, appointment])


    const renderTableContent = React.useCallback(() => {
        return (
            appointment?.map((item, index) => {
                return <AppointedIntepreterItem item={item?.interpreter} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInviteInterpreterPopUp} />
            })
        )
    }, [appointment, selectedItems]);

    const handleClose = React.useCallback(() => {
        refAddutton.current.click();
        setAddForm({ show: false })
    }, [])


    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                {/* <button
                    onClick={handleSubmitInviteInterpreters}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{

                        // float: "right",
                        marginRight: 20
                    }}
                >
                    Remove Interpreters
                </button> */}
            </div>
        )
    }, [selectedItems])
    return (
        <>
            <ListLayout
                title="Invited Interpreters - Email"
                addButtonDisabled={true}
                buttonTitle="Add InviteInterpreter"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchData}
                height={height}
                selectedItems={selectedItems}
                // handleRemoveItems={handleRemoveItems}
                // renderAddForm={<AddInviteInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} />}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddInviteInterpreterPopUp}
                renderFooter={renderFooter}
                hideRemoveButton={true}
                // loader={loader}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                showRemoveOnTop={true}
                containerStyle={{
                    marginTop: 20
                }}
                time={false}

            >


                {/* {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />} */}

                {/* <AddInviteInterpreter item={addForm.item} show={addForm.show} refAddutton={refAddutton} onClose={handleClose} /> */}
            </ListLayout>
            {/* Create full page Loader */}

        </>
    )

};

const AppointedIntepreterItem = ({
    item, index, selectedItems, handleChange, handleAddPopUp
}) => {
    const dispatch = useDispatch();

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            {/* <td>
                {item?.zip_code}
            </td> */}
            <td>
                {item?.user?.name}
            </td>
            <td>
                {item?.user?.email}
            </td>
            <td>
                {item?.phone}
            </td>
            {/* <td>
                {item?.languages?.map(l => l?.language?.name + ", ")}
            </td> */}

        </tr>
    )
}


export default AppointedInterpretersList